import {valuesMap,domElements,parameters} from '../utils/data';

export class MapboxService {
    mapsWrapper={};
    map = {};
    ubicationAllow=true;
    dealersDB = []
    constructor() {
      this.getMyUbication().then(res=>{
        if (!res)
         this.ubicationAllow=false;
      })
     
      if (typeof( MapboxService.instance) === "object")
        return MapboxService.instance
    
    MapboxService.instance = this;
    return this;

    }
       

      
      
  
    init(){
      this.map = new window.mapsWrapper.DynamicMap(domElements().MAP, {
        addCountryBoundaries: true,
        boundsPreservePaddingLeft: valuesMap().PADDING_LEFT,
        accessToken: process.env.REACT_APP_KEYMAPBOX,
        zoomControl: 'bottom-right',
        // center: [lng, lat],
        center: [-3, 40],
        zoom: 5.5
      });

  
    }
    getDealersByCoords(coord){
      if(coord)
       return fetch(`${process.env.REACT_APP_URL_DEALERS}/${coord[0]}/${coord[1]}
       ?count=${parameters.getDealers.count}
       &limitSearchDistance=${parameters.getDealers.distance}
       &isCurrentLocation=${parameters.getDealers.currentLocation}`);
    }
  
    async getDealersByParams(param){
      return new Promise(async res =>{
  
        try{
          let data = await fetch(`${process.env.REACT_APP_URL_DEALERS}/${parameters.getDealers.centerCoords[0]}/${parameters.getDealers.centerCoords[1]}
          ?count=${parameters.getDealers.maxCount}
          &limitSearchDistance=${parameters.getDealers.maxDistance}`)
          let dealers = await data.json();
          console.log(dealers)
          dealers.dealers= dealers.dealers.filter(dealer=>parseInt(dealer.localDealerID.split('-')[0])==parseInt(param))
          if (param.CodInstalacion)
             dealers.dealers= dealers.dealers.filter(dealer=>parseInt(dealer.localDealerID.split('-')[1])==parseInt(param.CodInstalacion))
          dealers.dealers=this.getWorkshopsinDealers(dealers.dealers)
          res(dealers.dealers);
        }
        catch{
          res([]);
        }
        }
      )
  
  
    }
    getWorkshopsinDealers(dealers){
      console.log(dealers)
      let dealersWithWorkshop = this.getDealersWithWorkshop(dealers);
      //console.log("dealers",dealersWithWorkshop)
      return dealersWithWorkshop;
    }
  
    getDealersWithWorkshop(dealers){
      return dealers.filter(dealer => {
        // return dealer.services.find(service => this.isWorkshop(service.service))    // Toyota
        return dealer.outletServices.find(service => this.isWorkshop(service.service)) // Lexus
      })
    }
    isWorkshop(service){
      // return (service==='WorkShop'||service==='BodyShop'||service==='PaintShop'|| service==='PartsShop')
      return service === 'WorkShop'
    }
  
  
    // getfilterDB(dealers){
  
    //   return dealers.filter((dealer,index,array) => {

    //     let dealerRS = this.isDealerDB(dealer.localDealerID);
    //     if (dealerRS){
    //         return true
    //     }
    //     return false;
        
    //   })    }

    //   isDealerDB(localDealerID){

    //     return dealersDB.find((dealer)=>
    //         parseInt(localDealerID.split('-')[0])+"-"+parseInt(localDealerID.split('-')[1])===parseInt(dealer.DealershipId.split('-')[0])+"-"+parseInt(dealer.DealershipId.split('-')[1])
    //     )
    //   }
    getMyUbication()
    {
  
      return new Promise(res=>{
        if (navigator.geolocation)
        navigator.geolocation.getCurrentPosition(pos=>res({center:[pos.coords['longitude'],pos.coords['latitude']]})
        ,err=>res(null))
        else res(null)
      })
    }
  
     getPlaceByCoords(coords){
  
      return new Promise(async res => {
        const address = await this.map['geocoder'].reverse([coords['center'][0],coords['center'][1]])
        res (address[0])
      })
  
    }
  
    getWorkshopsDB ()  {
      return this.service
        .get(
          `/Concesionario/GetConcesionariosByActivity?bMecanica=1&bChapa=0&bRepuestos=0`
        )
        .then(response => {
          this.dealersDB=response.Data;
        }
          
          )
        .catch(e => console.log(e));
    }; 


  }
  